var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "marker/pin") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "marker/pin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.9967708,20.3617706 C41.8290725,29.7499947 35.146806,37.7288518 25.953798,39.6077878 L26.0903162,39.5877752 C26.1035565,39.5868053 26.107717,39.5877797 26.107434,39.589951 L26.0978909,39.5993074 C26.0439551,39.6447191 26.0098261,39.706013 26.0011757,39.8945893 L25.999,40 C25.999,42.2079583 24.2095773,43.9979994 21.9981884,44 C19.8573247,43.99806 18.109834,42.3148037 18.0058914,40.1995341 L18.001,40 C18.001,39.7659018 17.9745762,39.6776528 17.9274002,39.6238525 L17.9021091,39.5993074 C17.8925884,39.5912913 17.8822173,39.5852561 17.8983866,39.5852409 L17.9742284,39.5944341 C8.73533487,37.7047628 2,29.544406 2,20 C2,8.9544305 10.9544305,0 22,0 C32.9305115,0 41.8132225,8.76885148 41.9970929,19.6555144 L42,20 L41.9967708,20.3617706 Z",
    id: "Fill-1",
    fillOpacity: 0.72,
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40,20 C40,10.059 31.941,2 22,2 C12.059,2 4,10.059 4,20 C4,28.699 10.171,35.957 18.375,37.635 C18.381,37.636 20.001,38.004 20.001,40 C20.001,41.104 20.896,41.999 22,42 C23.104,41.999 23.999,41.104 23.999,40 C23.999,38.004 25.619,37.636 25.625,37.635 C33.829,35.957 40,28.699 40,20",
    id: "Fill-1",
    fill: "#2C3032"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22,12 C25.3137085,12 28,14.6862915 28,18 C28,20.9727145 25.8381232,23.4404956 23.0008069,23.9169061 L23,30 C23,30.5522847 22.5522847,31 22,31 C21.4477153,31 21,30.5522847 21,30 L21.0001915,23.9170737 C18.1623839,23.4410745 16,20.9730632 16,18 C16,14.6862915 18.6862915,12 22,12 Z M22,14 C19.790861,14 18,15.790861 18,18 C18,20.209139 19.790861,22 22,22 C24.209139,22 26,20.209139 26,18 C26,15.790861 24.209139,14 22,14 Z",
    id: "Combined-Shape",
    fill: "#6BE2AD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/pin.4619c781c1732c9235e7a452556d6e54.svg";
export { ForwardRef as ReactComponent };